import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.RequestModule.AmountDueIndicator', {
    header: 'Please note that amount due is reduced by the following amounts fixed within another Batch Payment(s):',
    amountOnApproval: '• Amount on approval:',
    amountAwaitingPayment: '• Amount is approved and awaiting payment:',
    amountInProcessing: '• Amount in processing:',
    amountOnReview: '• Amount on review:',
});
